import React from "react";

//material ui
import { useTheme } from "@mui/styles";
import { Typography, Box, useMediaQuery } from "@mui/material";

//img
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: "center",
  },
  child: {
    width: { xs: "100%", md: "750px", lg: "970px", xl: "1455px" },
    mt: { xs: "84px", md: "-58px", lg: "-83px", xl: "-100px" },
    display: "flex",
    flexDirection: { xs: "column" },
    boxShadow: { md: "0 4px 100px 0 rgba(199, 206, 211, 0.25)" },
    borderRadius: { md: "47px" },
    height: { md: "200px", lg: "218px", xl: "327px" },
    alignItems: { xs: "center" },
    justifyContent: { xs: "center" },
    bgcolor: { md: theme.palette.white.main },
  },
  text: {
    fontSize: { xs: "23px", md: "15px", lg: "17px", xl: "27px" },
    lineHeight: { xs: "35px", md: "30px", lg: "34px", xl: "50px" },
    color: theme.palette.blue.main,
    fontFamily: theme.typography.montserrat.regular,
    width: { xs: "279px", md: "607px", lg: "924px", xl: "1205px" },
    textAlign: { xs: "center" },
  },
  span: {
    fontWeight: "bold",
  },
});

const BootcampText = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMediaQuery("(max-width:899px)");
  const { pathname } = useLocation();
  const componentName = "BootcampText";
  const translation = useTranslation(pathname, componentName);
  const { dotBackgroundImg, content } = translation;

  return (
    <Box sx={{ display: "flex", width: "100%", justifyContent: "center" }}>
      {!isMobile && dotBackgroundImg && (
        <img
          src={dotBackgroundImg.src}
          alt={dotBackgroundImg.alt}
          style={{ height: "150px", width: "60px" }}
        />
      )}
      <Box sx={classes.container}>
        <Box sx={classes.child}>
          <Typography sx={classes.text}>
            {content[0]}
            <span style={classes.span}>{content[1]}</span>
            {content[2]}
            <br></br>
            {content[3]} {content[4]}
            {content[5]}
            {content[6]}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default BootcampText;
